/**
 *  @function evalute - evaluate dateAddBehavior
 */

const moment = require('moment');
// const { pick } = require('lodash');

const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  // TODO: why does this work in tests and packaged behaviors, but not config behaviors?
  // const picked = pick(source, ['date', 'days', 'weeks', 'months', 'years']);
  // const evaluated = await evaluateSources(
  //   picked,
  //   content,
  //   parentContentPath,
  //   transientContext,
  //   nativeFunctions,
  // );
  // const { date: dateString, days = 0, weeks = 0, months = 0, years = 0 } = evaluated;

  const dateString = await evaluateSource(source.date, content, parentContentPath, transientContext, nativeFunctions);
  const timestamp = Date.parse(dateString);
  if (Number.isNaN(timestamp)) {
    return undefined;
  }
  const days = (await evaluateSource(source.days, content, parentContentPath, transientContext, nativeFunctions)) || 0;
  const weeks = (await evaluateSource(source.weeks, content, parentContentPath, transientContext, nativeFunctions)) || 0;
  const months = (await evaluateSource(source.months, content, parentContentPath, transientContext, nativeFunctions)) || 0;
  const years = (await evaluateSource(source.years, content, parentContentPath, transientContext, nativeFunctions)) || 0;
  return moment.utc(timestamp).add(days, 'days').add(weeks, 'weeks').add(months, 'months').add(years, 'years').toISOString();
};
module.exports = {
  evaluate
};